import { format, parseISO, differenceInCalendarDays } from 'date-fns'

function getDateDetails(startDatetime: string, endDatetime: string) {
  try {
    const currentDate = new Date()

    const parsedStartDate = parseISO(startDatetime)
    const parsedEndDate = parseISO(endDatetime)

    const formatedStartDate = format(parsedStartDate, 'M/d/yy')
    const formatedEndDate = format(parsedEndDate, 'M/d/yy')

    const endDateDistanceFromCurrentDay = differenceInCalendarDays(
      parsedEndDate,
      currentDate,
    )

    const startDateDistanceFromCurrentDay = differenceInCalendarDays(
      parsedStartDate,
      currentDate,
    )

    const dateDistance =
      differenceInCalendarDays(parsedEndDate, parsedStartDate) || 0

    let progressPercentage = 0

    if (
      startDateDistanceFromCurrentDay <= 0 // event started
    ) {
      // Total days minus days past divided by total days times 100 for percentage
      progressPercentage =
        ((dateDistance - endDateDistanceFromCurrentDay) / dateDistance) * 100
    }

    return {
      currentDate,
      parsedStartDate,
      parsedEndDate,
      formatedStartDate,
      formatedEndDate,
      startDateDistanceFromCurrentDay: Math.max(
        startDateDistanceFromCurrentDay,
        -1, // don't use 0, 0 means starting today, while -1 means started already
      ),
      endDateDistanceFromCurrentDay: Math.max(
        endDateDistanceFromCurrentDay,
        -1, // don't use 0, 0 means ending today, while -1 means ended already
      ),
      dateDistance,
      progressPercentage,
    }
  } catch (err) {
    console.error(err)
    return undefined
  }
}

export default getDateDetails
